import config from 'config'
import { useEffect } from 'react'

const useMortgageDetails = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const productId = searchParams.get('productId')
  const correlationId = searchParams.get('correlationId')

  useEffect(() => {
    const fetchData = async () => {
      if (!productId || !correlationId) return

      const response = await fetch(`${config.API_URL}/iress/get-product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId,
          correlationId,
        }),
      })
      const data = await response.json()
      console.log(data)
    }

    fetchData()
  }, [productId, correlationId])

  return { productId, correlationId }
}

export default useMortgageDetails
